import { DestroyRef, Injectable } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { TranslateService } from '@ngx-translate/core';
import { startWith } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class CrowdinTranslationService {
  constructor(private translateService: TranslateService) {}

  /**
   * handle translations and language changes for oyur component
   */
  watchLangChange(config: {
    loaderMap: Record<string, () => Promise<unknown>>;
    destroyRef: DestroyRef;
    successCallback?: () => void;
    errorCallback?: () => void;
  }) {
    this.translateService.onLangChange
      .pipe(startWith({ lang: this.translateService.currentLang }), takeUntilDestroyed(config.destroyRef))
      .subscribe(async event => {
        try {
          const fallback = await config.loaderMap[event.lang]();
          this.translateService.setTranslation(event.lang, fallback, true);
          if (config.successCallback) {
            config.successCallback();
          }
        } catch (fallbackError) {
          if (config.errorCallback) {
            config.errorCallback();
          }
          console.error(`Failed to load local fallback for ${event.lang}`, fallbackError);
          return;
        }
      });
  }
}
